export default __webpack_public_path__ + "static/media/BBB-blue.874edca6.svg";